export default __webpack_public_path__ + "static/media/search_gray.ae85e1ef.svg";